import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseUprightsColumnsStepsWorker } from '../workers/uprights-columns.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseUprightsColumnsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseUprightsColumnsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseUprightsColumnsStepsWorker | Remote<WarehouseUprightsColumnsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/uprights-columns.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseUprightsColumnsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseUprightsColumnsStepsWorker()];
  }
}

export class WarehouseDownloadUprightsColumnsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_UPC_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download uprights columns sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseUprightsColumnsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanUprightsColumnsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_UPC_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean uprights columns sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseUprightsColumnsSyncWorkerFactory(), taskBreaker);
  }
}
